export default __webpack_public_path__ + "static/media/logo.ab606ba5.svg";